import {
  spacingNano
} from '@deskfy/unify-design-tokens/jsvariables'

/* @ngInject */
function AdvancedSearchFiltersController ($scope, $rootScope, $attrs, $timeout, $translate, ToastService, UserService) {
  const hasPreFilters = true
  const api = {
    _loadData,
    _applyValues,
    _mountFilters,
    _errorLoadData,
    _customizeRows,
    _hasMoreResults,
    _getFiltersCount,
    _successLoadData,
    _applyDefaultValues,
    _setPaddingToContent,
    _handleEventClearAllFilters,
    _onCreatedAtRangeChange,
    _onDeliveryDateRangeChange,
    _onTemplateExpirationRangeChange,
    _getDateRangeHandler,
    _handleEventFilterApplied,
    _isFormEmpty
  }
  this.getApi = () => api

  $scope.form = {}
  $scope.dataComponents = {}

  activate()

  function activate () {
    if (!$scope.filters?.length) {
      $scope.filters = []
      return
    }
    api._mountFilters()
    $scope.filters.forEach(filter => filter?.value ? api._applyValues(filter) : api._applyDefaultValues(filter))
    $scope.onSubmit($scope.form, hasPreFilters, $scope.filtersCount)
  }

  const deregisterClearAllFilters = $scope.$on('advancedSearch.clearAllFilters', api._handleEventClearAllFilters)
  const deregisterFilterApplied = $scope.$on('advancedSearchFilter.filterApplied', (event, filters) => api._handleEventFilterApplied(filters))

  const deregisterOpenWatcher = $scope.$watch('isOpen', () => {
    if ($scope.isOpen) {
      api._mountFilters()
      api._setPaddingToContent()
    }
  })

  const deregisterFormWatcher = $scope.$watchCollection('form', () => {
    $scope.filtersCount = api._getFiltersCount($scope.form)
  })

  const deregisterValuesWatcher = $scope.$watchCollection(
    () => $scope.filters.map(filter => filter?.value).filter(Boolean),
    (newFilters, oldFilters) => {
      if (JSON.stringify(newFilters) === JSON.stringify(oldFilters)) return
      $scope.filters.forEach(filter => api._applyValues(filter))
    })

  $scope.$on('$destroy', () => {
    deregisterFormWatcher()
    deregisterOpenWatcher()
    deregisterClearAllFilters()
    deregisterValuesWatcher()
    deregisterFilterApplied()
  })

  $scope.onChange = (filter, event) => {
    if (event.detail && event.detail.option) {
      if (Array.isArray(event.detail.option)) {
        const selectedOptions = event.detail.option
        $scope.form[filter.name] = selectedOptions.map(selectedOption => selectedOption.value)
        return
      }

      const selectedOption = event.detail.option
      if (selectedOption) {
        $scope.form[filter.name] = selectedOption.value
        return
      }

      $scope.form[filter.name] = null

      return
    }

    if (event.detail && Array.isArray(event.detail)) {
      const selectedValues = event.detail
      $scope.form[filter.name] = selectedValues.map(selectedValue => selectedValue.value)
      return
    }

    if (event.detail && event.detail.date) {
      const selectedDate = event.detail.date
      $scope.form[filter.name] = selectedDate
      return
    }

    if (event.detail && event.detail?.value?.value) {
      const selectedValue = event.detail
      $scope.form[filter.name] = selectedValue.value.value || null
      return
    }

    const selectedValue = event.detail
    $scope.form[filter.name] = selectedValue?.value || null
  }

  $scope.onDateRangeChange = (filter, event) => {
    const handler = api._getDateRangeHandler(filter.name)

    if (handler) handler(filter, event)
  }

  $scope.onInfinite = (filter, event) => {
    const totalCount = event.detail?.totalCount
    const pagination = $scope.dataComponents[filter.name].pagination
    pagination.skip = pagination.top + pagination.skip

    api._loadData(null, filter, totalCount)
  }

  $scope.onSearch = (filter, event) => {
    const totalCount = event.detail?.totalCount
    const search = event.detail?.search || ''

    if ($scope.dataComponents[filter.name].pagination) {
      $scope.dataComponents[filter.name].pagination.skip = 0
    }

    api._loadData(search, filter, totalCount)
  }

  $scope.addFilters = () => {
    $scope.isOpen = false
    $scope.filtersCount = api._getFiltersCount($scope.form)

    if ($scope.onCount) {
      $scope.onCount($scope.filtersCount)
    }

    $scope.onSubmit($scope.form, false, $scope.filtersCount)
  }

  $scope.onPricingClick = (filter) => {
    const onClickHandler = filter?.props?.pricing?.onClick

    if (!onClickHandler || typeof onClickHandler !== 'function' || !filter.props.pricing?.show) {
      return
    }

    onClickHandler()
  }

  $scope.clearAllFilters = (ignoreSubmit = false) => {
    $scope.isOpen = false
    $rootScope.$emit('custom-fields.clear-all-filters')
    $scope.form = {}
    $scope.form.createdAtStart = null
    $scope.form.createdAtEnd = null
    $scope.form.deliveryDateStart = null
    $scope.form.deliveryDateEnd = null
    $scope.form.customFields = []

    $scope.filters.forEach(filter => {
      if (filter.name === 'createdAtRange' || filter.name === 'deliveryDateRange') {
        filter.defaultValue = ''
      }

      api._applyDefaultValues(filter)

      if ($scope.dataComponents[filter.name].pagination) {
        $scope.dataComponents[filter.name].pagination.top = 10
        $scope.dataComponents[filter.name].pagination.skip = 0
      }

      api._loadData(null, filter, null)
    })

    $scope.filtersCount = 0

    if ($scope.onCount) {
      $scope.onCount($scope.filtersCount)
    }

    $scope.onSubmit($scope.form, false, $scope.filtersCount, ignoreSubmit)

    if (ignoreSubmit) {
      $scope.$emit('advacedFilter.refreshDisplay', $scope.form)
    }

    const filtersWrapper = $attrs.$$element.find('.advanced-search-filters__wrapper')[0]
    const filterElements = filtersWrapper.querySelectorAll('.advanced-search__filters')

    $timeout(() => {
      filterElements.forEach(filterElement => {
        const filterId = filterElement.dataset.udsId
        const filterData = $scope.dataComponents[filterId]

        if (filterData.type === 'DATE_RANGE_PICKER') {
          filterElement.start = null
          filterElement.end = null
          filterElement.value = ''
          return
        }

        filterElement.value = filterData?.defaultValue ?? null
      })
    }, 0, true)
  }

  $scope.scrollToBottom = () => {
    $timeout(() => {
      const wrapper = $attrs.$$element.find('.advanced-search-filters__content')[0]
      if (wrapper) {
        wrapper.scrollTop = wrapper.scrollHeight
      }
    }, 100, false)
  }

  $scope.saveFilterClick = () => {
    if (api._isFormEmpty()) {
      ToastService.showErrorToast($translate.instant('selectFilterToSave'))
      return
    }

    $scope.isOpen = false
    $scope.onSaveFilter($scope.form)
  }

  function _mountFilters () {
    const search = ''
    const top = 10
    const skip = 0

    $scope.filters.forEach(filter => {
      $scope.dataComponents[filter.name] = {
        type: filter.type,
        value: filter,
        defaultValue: filter.defaultValue
      }

      if (filter.loadData) {
        $scope.dataComponents[filter.name].loadData = filter.loadData
        $scope.dataComponents[filter.name].pagination = { top, skip }
        filter.loadData(search, top, skip).then(response => api._successLoadData(filter, response))
      }
    })
  }

  function _loadData (search, filter, totalCount) {
    const dataComponents = $scope.dataComponents[filter.name]
    const pagination = dataComponents.pagination

    if (dataComponents.loadData) {
      dataComponents.loadData(search, pagination.top, pagination.skip)
        .then(response => api._successLoadData(filter, response, totalCount))
        .catch(api._errorLoadData)
    }
  }

  function _successLoadData (filter, response, totalCount = 0) {
    const data = response?.d?.results || response?.rows
    const count = response?.d?.__count || response?.count
    const optionsCount = totalCount || data.length

    filter.props.options = api._customizeRows(filter, data)
    filter.props.hasMoreOptions = api._hasMoreResults(optionsCount, count)
  }

  function _errorLoadData (error) {
    ToastService.defaultErrorToast()
    console.error({ error })
  }

  function _customizeRows (filter, rows, isActive) {
    const isFilterUser = filter.props.type === 'user'
    const createdAt = ''

    return rows.map(row => {
      const rowValue = row?.value || row.id
      return {
        ...row,
        id: filter.name,
        active: !!isActive,
        label: row?.label || row?.name || row?.title,
        value: rowValue,
        url: isFilterUser ? UserService.getUserProfileImage(row.id, createdAt) : null
      }
    })
  }

  function _hasMoreResults (totalCount, responseLength) {
    if (!responseLength) {
      return false
    }

    return responseLength > totalCount
  }

  function _getFiltersCount (filters) {
    return Object.entries(filters)
      .map(([key, value]) => {
        const isEmptyArray = Array.isArray(value) && !value.length
        const isEmptyValue = value === null || value === '' || value === undefined

        if (isEmptyArray || isEmptyValue) {
          return null
        }

        return key
      })
      .filter(Boolean)
      .length
  }

  function _applyDefaultValues (filter, originValue) {
    const hasObjectValue = typeof filter.defaultValue?.value !== 'undefined'
    if (filter.name === 'taskStatus' && originValue === 'INDICATOR_CARD_CLICKED') {
      if (Array.isArray(filter.defaultValue)) {
        $scope.form[filter.name] = filter.defaultValue.map(item => item.value).join(',')
      } else {
        $scope.form[filter.name] = filter.defaultValue.value
      }
    } else if (filter.name === 'createdAtRange' && originValue === 'INDICATOR_CARD_CLICKED') {
      $scope.form.createdAtStart = filter.defaultValue.start
      $scope.form.createdAtEnd = filter.defaultValue.end
    } else if (filter.name === 'deliveryDateRange' && originValue === 'INDICATOR_CARD_CLICKED') {
      $scope.form.deliveryDateStart = filter.defaultValue.start
      $scope.form.deliveryDateEnd = filter.defaultValue.end
    } else {
      if (hasObjectValue) {
        $scope.form[filter.name] = filter.defaultValue.value
      } else {
        $scope.form[filter.name] = filter.defaultValue
      }
    }
  }

  function _applyValues (filter) {
    if (Array.isArray(filter?.value)) {
      $scope.form[filter.name] = filter?.value.map(filterValue => filterValue?.value ?? filterValue)
      return
    }

    if (typeof filter.value?.value !== 'undefined') {
      $scope.form[filter.name] = filter.value.value
      return
    }

    $scope.form[filter.name] = filter.value ?? null
  }

  function _setPaddingToContent () {
    const filtersContentElement = $attrs.$$element.find('.advanced-search-filters__wrapper .advanced-search-filters__content')[0]

    const notHasPadding = !filtersContentElement.style.paddingRight
    const contentHeight = filtersContentElement.clientHeight
    const maxHeight = 450

    if (contentHeight === maxHeight && notHasPadding) {
      filtersContentElement.style.paddingRight = spacingNano
    }
  }

  function _handleEventClearAllFilters (event, ignoreSubmit = false) {
    $scope.clearAllFilters(ignoreSubmit)
  }

  function _getDateRangeHandler (filterName) {
    const handlers = {
      createdAtRange: api._onCreatedAtRangeChange,
      deliveryDateRange: api._onDeliveryDateRangeChange,
      templateExpirationRange: api._onTemplateExpirationRangeChange,
      default: null
    }

    if (handlers[filterName]) return handlers[filterName]
    return handlers.default
  }

  function _onCreatedAtRangeChange (filter, event) {
    if (event.detail && (event.detail?.start || event.detail?.end)) {
      const dates = event.detail

      $scope.form.createdAtStart = dates.start || null
      $scope.form.createdAtEnd = dates.end || null
    } else {
      $scope.form.createdAtStart = null
      $scope.form.createdAtEnd = null
    }
  }

  function _onTemplateExpirationRangeChange (filter, event) {
    if (event.detail && (event.detail?.start || event.detail?.end)) {
      const dates = event.detail

      $scope.form.templateExpirationStart = dates.start || null
      $scope.form.templateExpirationEnd = dates.end || null
    }
  }

  function _onDeliveryDateRangeChange (filter, event) {
    if (event.detail && (event.detail?.start || event.detail?.end)) {
      const dates = event.detail

      $scope.form.deliveryDateStart = dates.start || null
      $scope.form.deliveryDateEnd = dates.end || null
    } else {
      $scope.form.deliveryDateStart = null
      $scope.form.deliveryDateEnd = null
    }
  }

  function _handleEventFilterApplied (filters) {
    filters.forEach(filter => {
      api._applyDefaultValues(filter, 'INDICATOR_CARD_CLICKED')
    })
  }

  function _isFormEmpty () {
    return Object.values($scope.form).every(value => value === null || value === '' || value === undefined || !value.length)
  }
}

export { AdvancedSearchFiltersController }
